import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7450dbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

import locales from './CoachingSessionQuestion.locales.en.json'
import BarButton from '@/components/BarButton'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSessionQuestion',
  props: {
    href: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", { href: _ctx.href }, [
    _createVNode(_unref(BarButton), {
      id: "button-link",
      class: "mx-0",
      mode: "outline"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(locales).link_ask_question), 1)
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}
}

})